import { render, staticRenderFns } from "./ChannelView.vue?vue&type=template&id=e515e84c&scoped=true"
import script from "./ChannelView.vue?vue&type=script&lang=js"
export * from "./ChannelView.vue?vue&type=script&lang=js"
import style0 from "./ChannelView.vue?vue&type=style&index=0&id=e515e84c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e515e84c",
  null
  
)

export default component.exports